import styled from "styled-components";

const Container = styled.nav`
  width: 100%;
  max-width: 270px;
  margin: 25px 0px 0px 0px;
  display: flex;
  justify-content: center;

  button {
    width: auto;
    height: auto;
    padding: 0px;
    margin: 0px 10px 0px 10px;
    border: 0px;
    background-color: white;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    cursor: pointer;
  }

  p {
    text-align: center !important;
    color: var(--lightblue) !important;
    font-family: Raleway;
    font-style: normal !important;
    font-weight: bold !important;
    font-size: 16px !important;
    margin: 0px !important;
    transition: 0.1s all;
  }

  .activeP {
    color: var(--blue) !important;
  }

  .activeSpan {
    width: 100%;
    height: 2px;
    background-color: var(--blue);
    margin: 5px 0px 0px 0px;
  }

  button:hover > p {
    color: var(--black) !important;
  }

  button:hover > .activeSpan {
    background-color: var(--black) !important;
  }
`;

export default Container;
